/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { FeApi } from '@/api/fe-api';

import type { BodyOf } from '../fetch-client';
import { useFetchOpts } from '../use-fetch-opts';

export namespace ListFrontendIds {
  export const key = (input: Input) => [
    'task-manager',
    'list-frontend-ids',
    input.level,
  ];

  export type QueryParams = {};

  export type Input = { level: string };

  export type Output = {
    ids: string[];
  };

  function outputFromBody(data: FeApi.ListIdViewOutput): Output {
    return {
      ids: data.ids,
    };
  }

  function bodyFromInput(
    input: Input,
  ): BodyOf<typeof FeApi.customerInfosV1CustomerIdsRetrieve> {
    return {
      level: input.level,
    };
  }

  export function useQuery(input?: Input) {
    const getOpts = useFetchOpts();

    return rq.useQuery<Output>({
      enabled: Boolean(input),
      queryKey: input ? key(input) : undefined,
      async queryFn({ signal }) {
        const opts = await getOpts();
        const body = bodyFromInput(input!);
        const data = await FeApi.customerInfosV1CustomerIdsRetrieve(body, {
          ...opts,
          signal,
        });

        if (data.status !== 200) {
          throw new Error('Failed to fetch frontend ids');
        }

        return outputFromBody(data.data);
      },
    });
  }
}
